import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    release: process.env.REACT_APP_VERSION,
    tracesSampleRate: 0.1,
    integrations: [Sentry.browserTracingIntegration()],
    beforeSend(event) {
      if (process.env.NODE_ENV === 'development') return null;
      return event;
    },
  });
}

// Suppress Firestore errors from crashing the React dev overlay
window.addEventListener('error', e => {
  const msg = e?.message || '';
  if ((msg.includes('FIRESTORE') && msg.includes('INTERNAL ASSERTION')) ||
      msg.includes('Missing or insufficient permissions')) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }
});
window.addEventListener('unhandledrejection', e => {
  const msg = e?.reason?.message || '';
  if ((msg.includes('FIRESTORE') && msg.includes('INTERNAL ASSERTION')) ||
      msg.includes('Missing or insufficient permissions')) {
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

reportWebVitals();
